@export const SH_DIFFUSE = array(

  vec3<f32>( 0.407463, 0.512907, 0.560060),
  vec3<f32>( 0.304353, 0.406098, 0.547452),
  vec3<f32>( 0.039094, 0.041564,-0.038478),
  vec3<f32>( 0.051974, 0.022462,-0.049525),
  vec3<f32>( 0.012576,-0.021732,-0.073779),
  vec3<f32>( 0.015867, 0.016420,-0.013053),
  vec3<f32>( 0.017854, 0.015396, 0.007058),
  vec3<f32>( 0.031431, 0.049632, 0.095778),
  vec3<f32>( 0.042348, 0.038642, 0.002004),

);

@export const SH_SPECULAR = array(

  vec3<f32>( 0.129699, 0.163263, 0.178273),
  vec3<f32>( 0.145318, 0.193897, 0.261389),
  vec3<f32>( 0.018666, 0.019845,-0.018372),
  vec3<f32>( 0.024816, 0.010725,-0.023646),
  vec3<f32>( 0.016012,-0.027670,-0.093938),
  vec3<f32>( 0.020203, 0.020906,-0.016619),
  vec3<f32>( 0.022733, 0.019603, 0.008986),
  vec3<f32>( 0.040020, 0.063194, 0.121948),
  vec3<f32>( 0.053919, 0.049201, 0.002551),
  vec3<f32>( 0.008604, 0.010379, 0.010502),
  vec3<f32>( 0.036525, 0.123163, 0.308115),
  vec3<f32>( 0.066994, 0.080063, 0.085160),
  vec3<f32>(-0.000887, 0.002242,-0.000136),
  vec3<f32>( 0.005252, 0.003595,-0.006013),
  vec3<f32>( 0.060987, 0.027511,-0.024443),
  vec3<f32>(-0.010356, 0.006443, 0.049597),

);